<template>
    <div>
        <b-modal :id="id" size="lg">
            <template v-slot:modal-header="{ close }">
                <h3 class="w-100 text-center">{{ title }}</h3>
                <button type="button" class="close" @click="closeModal()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">{{ __("close") }}</span>
                </button>
            </template>
            <template v-slot:default>
                <form
                    id="contract-period-form"
                    :action="action"
                    method="post"
                    class="row form m-b-sm"
                >
                    <input type="hidden" name="_token" :value="csrf" />
                    <input
                        type="hidden"
                        name="period[status]"
                        :value="period.status"
                    />
                    <input
                        type="hidden"
                        name="period[id]"
                        :value="period.id"
                        v-if="period.id != undefined"
                    />

                    <div
                        class="col-md-2"
                        :class="
                            hasError('period.start_date') ? 'has-error' : ''
                        "
                    >
                        <label>{{ __("starting_date") }}*</label>
                        <div class="input-group date">
                            <date-picker
                                class="col-12 p-0 m-0"
                                name="period[start_date]"
                                :value="setDatepickerValue()"
                                @change="setPeriodDate($event)"
                                :options="datePickerOptions"
                                :setDatepickerDate="true"
                            />
                        </div>
                        <span
                            class="help-block text-danger"
                            v-if="hasError('period.start_date')"
                        >
                            {{ getError("period.start_date") }}
                        </span>
                    </div>
                    <div
                        class="col-md-2"
                        :class="
                            hasError('period.billing_method') ? 'has-error' : ''
                        "
                    >
                        <label>{{ __("billing_method") }}*</label>
                        <select2
                            :settings="{ width: '100%' }"
                            name="period[billing_method]"
                            v-model="period.billing_method"
                            @change="handleBillingPeriod()"
                            :readonly="period.status == 'active'"

                        >
                            <option :value="null">---</option>
                            <option value="free">{{ __("free") }}</option>
                            <option value="cspoints">{{ __("cspoints") }}</option>
                            <option value="pre_paid">{{
                                    __("pre_paid")
                                }}</option>
                            <option value="subscription">{{ __("subscription") }}</option>
                        </select2>
                        <span
                            class="help-block text-danger"
                            v-if="hasError('period.billing_method')"
                        >
                            {{ getError("period.billing_method") }}
                        </span>
                    </div>
                    <div
                        class="col-md-2"
                        :class="
                            hasError('period.billing_period') ? 'has-error' : ''
                        "
                    >
                        <label>{{ __("billing_period") }}*</label>
                        <select2
                            :settings="{ width: '100%' }"
                            name="period[billing_period]"
                            :options="billingPeriodOptions()"
                            class="billing-period"
                            v-model="period.billing_period"
                            @change="setCheckboxesState"
                            :readonly="period.billing_period == null || period.billing_period_disabled == true || period.billing_method == 'free' || period.billing_method =='cspoints' ||period.status == 'active'"

                        >

                        </select2>
                        <span
                            class="help-block text-danger"
                            v-if="hasError('period.billing_period')"
                        >
                            {{ getError("period.billing_period") }}
                        </span>
                    </div>

                    <div
                        class="col-md-2"
                        :class="
                            hasError('period.max_documents') ? 'has-error' : ''
                        "
                    >
                        <input-wrapper
                            :labelClass="'white-space-no-wrap'"
                            :label="__('max_doc_monthly_short') + '*'"
                            type="number"
                            classNames="form-control "
                            name="period[max_documents]"
                            v-model="period.max_documents"
                            :errors="getErrors('period.max_documents')"
                        />
                    </div>

                    <div
                        class="col-md-2"
                        :class="hasError('period.max_users') ? 'has-error' : ''"
                    >
                        <input-wrapper
                            :label="__('max_users') + '*'"
                            type="number"
                            classNames="form-control "
                            name="period[max_users]"
                            v-model="period.max_users"
                            :errors="getErrors('period.max_users')"
                        />
                    </div>

                    <div class="col-md-12 m-t-sm">
                        <label>
                            <input
                                type="checkbox"
                                name="period[departments]"
                                value="true"
                                v-model="period.departments"
                                :disabled="isDisabledDepartmentsCheckbox || departmentDisabled"
                            />
                            {{ __("ability_to_add_departments") }}
                        </label>
                    </div>
                </form>
            </template>
            <template v-slot:modal-footer>
                <button
                    type="button"
                    class="btn btn-white"
                    @click="closeModal()"
                >
                    {{ __("cancel") }}
                </button>
                <button
                    type="submit"
                    form="contract-period-form"
                    class="btn btn-primary"
                >
                    {{ __("save") }}
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import DatePicker from "../form/DatePicker.vue";
import InputWrapper from "../form/InputWrapper.vue";

export default {
    components: { InputWrapper, DatePicker },

    data: () => ({
        mode: "create",
        csrf: document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
        periodDate: null,
        period: {
            start_date: moment().format("YYYY-MM-DD"),
            billing_period: "no_billing",
            max_documents: 0,
            max_users: 1,
            subscription: false,
            departments: false,
            status: "pending",
            billing_method: "none",
        },
        departmentDisabled: false,
        errors: []
    }),
    props: {
        id: {
            type: String,
            default: "modal"
        },
        titleCreate: String,
        titleEdit: String,
        action: String,
        old: [Array, Object],
        validationErrors: [Array, Object],
        disabledPeriodDates: {
            type: Array,
            default: []
        },
        periodStartDate: {
            type: String
        }
    },
    computed: {
        title() {
            return this.mode == "create" ? this.titleCreate : this.titleEdit;
        },
        filteredSelectedPeriodDate() {
            let thisDate = this.periodDate;
            return this.disabledPeriodDates.filter(date => {
                return date != thisDate;
            });
        },
        datePickerOptions() {
            return {
                todayBtn: "linked",
                format: "yyyy-mm-dd",
                todayHighlight: true,
                autoclose: true,
                startDate:
                    this.period.status == "active"
                        ? this.periodDate
                        : this.periodStartDate,
                value:
                    this.mode == "edit"
                        ? this.periodDate
                        : this.periodStartDate,
                enableOnReadonly: false,
                readonly: this.period.status == "active",
                datesDisabled: this.filteredSelectedPeriodDate
            };
        },
        isDisabledSubscriptionCheckbox() {
            return this.period.billing_period == 'no_billing';
        },
        isDisabledDepartmentsCheckbox() {
            return this.period.billing_period == 'no_billing';
        }
    },
    methods: {
        billingPeriodOptions(){
            if(this.period.billing_method != 'subscription' && this.period.billing_method !='pre_paid')
            {
                return [
                    {id:null, text:'---',},
                    {id:'no_billing', text:$.i18n._("no_billing"),},
                    {id:'month', text:$.i18n._("month"),},
                    {id:'quarter', text:$.i18n._("quarter"),},
                    {id:'half_year', text:$.i18n._("half_year"),},
                    {id:'year', text:$.i18n._("year"),},


                ];
            }
            else{
                return [
                    {id:'month', text:$.i18n._("month"),},
                    {id:'quarter', text:$.i18n._("quarter"),},
                    {id:'half_year', text:$.i18n._("half_year"),},
                    {id:'year', text:$.i18n._("year"),},


                ];
            }
        },
        handleBillingPeriod(){
            if(this.period.billing_method == 'cspoints' || this.period.billing_method == 'free'){
                this.period.billing_period = 'no_billing';
                $('.billing-period').trigger('change')
                $('.billing-period').trigger('select2:select')
                this.period.billing_period_disabled = true;
                this.departmentDisabled = true;

            }
            else if(this.period.billing_method == null || this.period.billing_method == ''){
                this.period.billing_period = null;
                this.period.billing_period_disabled = true;
                this.departmentDisabled = true;
            }
            else{
                this.period.billing_period = 'month';
                this.period.billing_period_disabled = false;
                this.departmentDisabled = false;
            }
            this.setCheckboxesState()
        },
        openModal(mode, data) {
            this.mode = mode;

            if (mode == "edit" || (mode == "create" && data)) {
                this.period = { ...data };
                this.periodDate = data.start_date;
            } else {
                this.clearForm();
            }

            this.$bvModal.show(this.id);
            this.handleBillingPeriod()
        },
        closeModal() {
            this.$bvModal.hide(this.id);
            this.clearForm();
            this.clearErrors();
        },
        clearForm() {
            this.period = {
                start_date: moment().format("YYYY-MM-DD"),
                billing_period: null,
                billing_period_disabled: false,
                max_documents: 0,
                max_users: 1,
                subscription: false,
                departments: false,
                status: "pending",
                billing_method: null,
            };
        },
        setDatepickerValue: function() {
            return moment(
                (this.mode == "edit" || this.mode == "create" && !Array.isArray(this.old)) ? this.periodDate : this.periodStartDate
            ).format("YYYY-MM-DD");
        },
        setPeriodDate(val) {
            this.period.start_date = val;
        },
        restoreOldValues() {
            this.note.title = this.old.title;
            this.note.content = this.old.content;
        },
        hasAnyError() {
            for (const [key, value] of Object.entries(this.errors)) {
                if (value.length > 0) {
                    return true;
                }
            }

            return false;
        },
        clearErrors() {
            for (const [key, value] of Object.entries(this.errors)) {
                this.errors[key] = [];
            }
        },
        hasError(inputName) {
            return (
                this.errors[inputName] != undefined &&
                this.errors[inputName].length > 0
            );
        },
        getError(inputName) {
            return this.errors[inputName] != undefined
                ? this.errors[inputName][0]
                : "";
        },
        getErrors(inputName) {
            return this.errors[inputName] != undefined
                ? this.errors[inputName]
                : [];
        },
        setCheckboxesState() {
            if(this.period.billing_period == 'no_billing') {
                this.period.subscription = false;
                this.period.departments = false;
            }
        }
    },
    mounted() {
        this.errors = this.validationErrors;
        if (this.hasAnyError()) {
            this.openModal(this.old.id > 0 ? "edit": "create", this.old);
        }
    }
};
</script>
